import { useQuery } from '@apollo/client';
import UserWishlist from '@website/components/Wishlist/UserWishlist';
import { UserDashboardDocument } from '@website/types/graphqlOperations';
import { ParsedUrlQuery } from 'querystring';
import LoadingPage from '../../utilities/LoadingPage';
import { CustomerDashboardLayout } from './CustomerDashboardLayout';

type Props = {
  query: ParsedUrlQuery;
};

export function CustomerWishlist({ query }: Props) {
  const { userID } = query;

  // API calls
  const { loading, data } = useQuery(UserDashboardDocument, {
    variables: { id: userID as string },
    // incase of error, please also return data as well this could be a permissions
    // issue
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  if (loading && !data) {
    return <LoadingPage />;
  }

  const { user } = data;

  return (
    <CustomerDashboardLayout activeTab="Wishlist" userID={userID as string}>
      <h5 className="px-2">Wishlist</h5>
      <UserWishlist wishlist={user.wishlist.items} />
    </CustomerDashboardLayout>
  );
}
